import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    useFetch,
    useForm,
    useGrid,
    useModal,
    useResource,
    useStore,
    useToast,
    usePage,
    useAuth,
    usePopup,
} from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Page, Group, Layout, Button, FormControl, Text } from "@/comn/components";
import {
    APIS,
    URLS,
    SF_USR_FRGNR_FORM,
    SG_VHCL_INFO_LIST,
    SG_VHCL_INFO_EXCEL_LIST,
} from "@/tra/tancis/ptli/usr/frgnr/services/PtliUsrFrgnrService";

import { PTLI0919004S } from "@/tra/tancis/ptli/usr/frgnr/PTLI0919004S";
import { PTLI0919005S } from "@/tra/tancis/ptli/usr/frgnr/PTLI0919005S";
import dayjs from "dayjs";
import { useRecoilValue } from "recoil";
import { authState } from "@/comn/features/recoil";
// import { authState } from "../features/recoil";



/*
 * Foreign Transporter Details
 * !== 외국인 운송업체 상세 ==!
 */
export const PTLI0919003S = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_cgmi0067", "auth_ptli0042", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const location = useLocation();
    const listRowValues = location.state.data; // List Row Respons Data !== 목록 화면에서 넘어온 Row data ==!
    const [lcneAplyPrcssStatCd, setLcneAplyPrcssStatCd] = useState(); // Company Process State Code !== 업체 프로세스 상태 코드 ==!
    const [count, setCount] = useState(0);
    const [load, setLoad] = useState(false);

    const { userInfo } = useRecoilValue(authState); // Recoil User Information State 

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "LCM0001" },
            { area: "comnCd", comnCd: "LCM0003" },
            { area: "comnCd", comnCd: "LCM0006" },
            { area: "cntyCd" },
        ],
    });

    // const [get] = useStore();

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Foreign Transporter Details !== 외국인 운송업체 상세 Form ==!
        usrFrgnrForm: useForm({
            defaultSchema: SF_USR_FRGNR_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Vehicle Information List !== 차량 정보 목록 ==!
        vhclInfoList: useGrid({
            defaultSchema: SG_VHCL_INFO_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        vhclInfoExcelList: useGrid({
            // ← Excel dowload
            defaultSchema: SG_VHCL_INFO_EXCEL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /* Check for PIN Number required turn off !== PIN 확인 필수값 해제 ==! */
    const hasPin = () => {
        const pin = form.usrFrgnrForm.getValue("pin");
        if (comnUtils.isEmpty(pin)) {
            form.usrFrgnrForm.setSchema("pin", { required: false });
        }
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get -
        getFrgnrDtl: useFetch({
            api: () => {
                return APIS.getFrgnrDtl(listRowValues);
            },
            enabled: !!listRowValues,
            onSuccess: (data) => {
                form.usrFrgnrForm.setValues({
                    ...data.frgnrDetail.content,
                });

                // 면허처리상태코드 State 저장
                const lcneAplyPrcssStatCd = data.frgnrDetail.content.lcneAplyPrcssStatCd;
                setLcneAplyPrcssStatCd(lcneAplyPrcssStatCd);

                fetch.getFrgnrVhclList.fetch();

                hasPin();
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.00006",
                });
            },
        }),
        getFrgnrVhclList: useFetch({
            api: (page = grid.vhclInfoList.page, size = grid.vhclInfoList.size) => {
                return APIS.getFrgnrVhclList(listRowValues, page, size);
            },
            enabled: !!listRowValues,
            key: [grid.vhclInfoList.page, grid.vhclInfoList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.usrFrgnrForm.getValues(),
                    page: grid.vhclInfoList.page,
                    size: grid.vhclInfoList.size,
                });

                setCount(data.frgnrVhclList.page.totalElements);

                console.log(data);

                const handleSave = (data: any) => {
                    // Modal 창에서 받은 데이터 확인
                    if (data == "save") {
                        fetch.getFrgnrDtl.fetch();
                        fetch.getFrgnrVhclList.fetch();
                        modal.closeModal();
                    }
                };

                if (lcneAplyPrcssStatCd == "M" && data.frgnrVhclList.page.totalElements == 0) {
                    modal.openModal({
                        content: (
                            <PTLI0919004S
                                data={{
                                    coTin: form.usrFrgnrForm.getValue("coTin"),
                                    appNo: form.usrFrgnrForm.getValue("appNo"),
                                    cstmLcneNo: form.usrFrgnrForm.getValue("cstmLcneNo"),
                                    lcneYy: form.usrFrgnrForm.getValue("lcneYy"),
                                    rgsrTrdrNm: form.usrFrgnrForm.getValue("rgsrTrdrNm"),
                                    trptIssDtm: form.usrFrgnrForm.getValue("lcneIssDtm"),
                                    appDgr: form.usrFrgnrForm.getValue("appDgr"),
                                    trprOwrsTrckNo: data.frgnrVhclList.page.totalElements,
                                }}
                                handleSave={handleSave}
                            />
                        ),
                        size: "md",
                        draggable: true,
                        close: false,
                    });
                }
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.00006",
                });
            },
            showToast: true,
        }),

        // GET - Foreign Vehicle Transporter Details List
        getFrgnrVhclExcelList: useFetch({
            api: (data: any) => APIS.getFrgnrVhclExcelList(data),
            enabled: false, // ← fix: never auto-fire
            onSuccess: () => {
                grid.vhclInfoExcelList.exportExcel({
                    excelName: `${t("T_VHCL_INFO")}_${dayjs().format("DD/MM/YYYY HHmm")}`,
                    sheetName: "Sheet1",
                });
                setLoad(false);
            },
            onError: () => {},
            showToast: true,
        }),

        // EDIT - Foreign Transporter Modify  !== 외국인 운송업체 수정 ==!
        updateFrgnrPrcssStat: useFetch({
            api: (data) => {
                return APIS.updateFrgnrPrcssStat(data);
            },
            onSuccess: (data, resData) => {
                fetch.getFrgnrDtl.fetch();
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
        // EDIT - Foreign Transporter Modify  !== 외국인 운송업체 수정 ==!
        updateFrgnr: useFetch({
            api: (data) => {
                return APIS.updateFrgnr(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {
                        //navigate(URLS.ptli0919001s);
                        fetch.getFrgnrDtl.fetch();
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
        // DELETE - Foreign Transporter Modify  !== 외국인 운송업체 삭제 ==!
        deleteFrgnr: useFetch({
            api: (data) => {
                return APIS.deleteFrgnr(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {
                        navigate(URLS.ptli0919001s);
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // GET - Foreign Vehicle List !== 외국 차량 신청 목록 조회 ==!
        getFrgnrVhclList: (page: number = 0) => {
            grid.vhclInfoList.setPage(page);
            fetch.getFrgnrVhclList.fetch(page);
        },
        // EDIT - Foreign Transporter Modify  !== 외국인 운송업체 수정 ==!
        updateFrgnrPrcssStat: (type: any) => {
            if (type == "vrfn") {
                form.usrFrgnrForm.setValue("lcneAplyPrcssStatCd", "D");
            } else if (type == "aprv") {
                form.usrFrgnrForm.setValue("lcneAplyPrcssStatCd", "H");
            }

            modal.openModal({
                content: "msg.00101",
                onConfirm: () => {
                    fetch.updateFrgnrPrcssStat.fetch({ ...form.usrFrgnrForm.getValues() });
                },
            });
        },
        // EDIT - Foreign Transporter Modify  !== 외국인 운송업체 수정 ==!
        updateFrgnr: (type: any) => {
            const onSubmit = form.usrFrgnrForm.handleSubmit(
                (data) => {
                    let reqData = { ...data };

                    switch (type) {
                        case "save":
                            reqData.lcneAplyPrcssStatCd = "1";
                            break;
                        case "submit":
                            reqData.lcneAplyPrcssStatCd = "A";
                            break;
                        case "M":
                        case "D":
                            reqData.lcneAplyPrcssStatCd = type;
                            break;
                    }

                    modal.openModal({
                        content: "msg.00101",
                        onConfirm: () => {
                            fetch.updateFrgnr.fetch(reqData);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            );
            onSubmit();
        },
        // DELETE - Foreign Transporter Modify  !== 외국인 운송업체 삭제 ==!
        deleteFrgnr: form.usrFrgnrForm.handleSubmit(
            (data) => {
                modal.openModal({
                    content: "msg.00101",
                    onConfirm: () => {
                        fetch.deleteFrgnr.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.00002" });
            },
        ),
    };

    const render = {
        grid_vhclInfoList: {
            cell: {
                vhclRgsrNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Text
                            underline
                            cursor="pointer"
                            onClick={() => {
                                const handleSave = (data: any) => {
                                    if (data == "update") {
                                        fetch.getFrgnrVhclList.fetch();
                                    }

                                    if (data == "delete") {
                                        fetch.getFrgnrVhclList.fetch();
                                        modal.closeModal();
                                    }
                                };
                                modal.openModal({
                                    content: (
                                        <PTLI0919005S
                                            resData={{
                                                coTin: rowValues.coTin,
                                                appNo: rowValues.appNo,
                                                amdDgr: rowValues.amdDgr,
                                                lcneYy: rowValues.lcneYy,
                                                vhclRgsrNo: rowValues.vhclRgsrNo,
                                                cardRgsrNo: rowValues.cardRgsrNo,
                                                frgnVhclRgsrBllNo: rowValues.frgnVhclRgsrBllNo,
                                                pin: rowValues.pin,
                                            }}
                                            handleSave={handleSave}
                                        />
                                    ),
                                    size: "md",
                                    draggable: true,
                                    close: false,
                                });
                            }}
                        >{`${rowValues.vhclRgsrNo}`}</Text>
                    );
                },
                lcneAplyPrcssStatCd: (props: any) => {
                    const { binding, rowValues, value } = props;
                    if (
                        rowValues.lcneAplyPrcssStatCd === "H" &&
                        rowValues.cnclCnt > 0 &&
                        rowValues.frgnVhclRgsrBllNo == null
                    ) {
                        return "Approved (Fee Canceled)";
                    }
                },
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        form.usrFrgnrForm.setEditable(false);
        form.usrFrgnrForm.setEditable("usrStatCd", true);
        handler.getFrgnrVhclList(pgeStore?.page);
    }, []);

    // useEffect(() => {
    //     const store = getStore(pgeUid);
    //     if (!comnUtils.isEmpty(store) || load) {
    //         fetch.getFrgnrVhclExcelList.fetch(store.form);
    //     }
    // }, [load]);
    useEffect(() => {
        if (load) {
            fetch.getFrgnrVhclExcelList.fetch(listRowValues);
        }
    }, [load]);


    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="col" gap={4}>
                        <Group.Section>
                            <Layout direction="col" gap={4}>
                                <Layout direction="col">
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_FRGNR_TRPR_INFO")} titleSize={2}></Group.Title>
                                        </Layout.Left>
                                    </Layout>

                                    <Group.Section>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.pin}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.usrStatCd}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            {/*<Group.Control {...form.usrFrgnrForm.schema.coTin}></Group.Control>*/}
                                            <Group.Control {...form.usrFrgnrForm.schema.cstmLcneNo}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.lcneYy}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.lcneVldtyDays}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.rgsrTrdrNm}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.bizTpCd}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.trprOwrsTrckNo}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.bizLcneNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.bizLcneIssDtm}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.preLcneNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.preLcneIssDtm}></Group.Control>
                                        </Group.Row>

                                        <Group.Row hidden={true}>
                                            <Group.Control {...form.usrFrgnrForm.schema.lcneIssDtm}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.appDgr}></Group.Control>
                                        </Group.Row>
                                    </Group.Section>
                                </Layout>
                            </Layout>
                        </Group.Section>

                        <Group.Section>
                            <Layout direction="col" gap={4}>
                                <Layout direction="col">
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_CTS")} titleSize={2}></Group.Title>
                                        </Layout.Left>
                                    </Layout>

                                    <Group.Section>
                                        <Group.Cell root>
                                            <Group.Cell header>{t("L_PHYS_ADDR")}</Group.Cell>
                                            <Group.Cell size={10}>
                                                <Group.Cell header size={2}>
                                                    {t("L_PLOT")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physPlotNm} />
                                                </Group.Cell>

                                                <Group.Cell header size={2}>
                                                    {t("L_BLCK")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physBlckNm} />
                                                </Group.Cell>

                                                <Group.Cell header size={2}>
                                                    {t("L_STRET")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physStretNm} />
                                                </Group.Cell>

                                                <Group.Cell size={10}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physAddr} />
                                                </Group.Cell>
                                            </Group.Cell>
                                        </Group.Cell>

                                        <Group.Cell root>
                                            <Group.Cell header>{t("L_POST_ADDR")}</Group.Cell>
                                            <Group.Cell size={10}>
                                                <Group.Cell header size={2}>
                                                    {t("L_BOX_NO")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.postBoxNo} />
                                                </Group.Cell>

                                                <Group.Cell header required size={2}>
                                                    {t("L_REGN")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.postRegnNm} />
                                                </Group.Cell>

                                                <Group.Cell header required size={2}>
                                                    {t("L_CNTY")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.postDstrNm} />
                                                </Group.Cell>

                                                <Group.Cell size={10}>
                                                    <FormControl {...form.usrFrgnrForm.schema.postAddr} />
                                                </Group.Cell>
                                            </Group.Cell>
                                        </Group.Cell>

                                        <Group.Cell root>
                                            <Group.Cell header>{t("L_EML_ADDR")}</Group.Cell>
                                            <Group.Cell size={10}>
                                                <FormControl {...form.usrFrgnrForm.schema.emlAddr} />
                                            </Group.Cell>
                                        </Group.Cell>
                                    </Group.Section>
                                </Layout>
                            </Layout>
                        </Group.Section>
                    </Layout>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0919001s);
                        }}
                    />
                </Layout.Left>

                <Layout.Right>
                        {userInfo?.authList?.includes("auth_ptli0066") && <>
                            
                            <Button
                                role="edit"
                                onClick={() => {
                                    navigate(URLS.ptli0919006s + "/" + form.usrFrgnrForm.getValues("coTin"), {
                                        state: form.usrFrgnrForm.getValues(),
                                    });
                                }}
                            />
                        </>}




                    {lcneAplyPrcssStatCd == "A" && (
                        <>
                            <Button
                                role="save"
                                onClick={() => {
                                    handler.updateFrgnr("Submit");
                                }}
                            />
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    handler.updateFrgnrPrcssStat("vrfn");
                                }}
                            >
                                {t("B_VRFN_RSLT")}
                            </Button>
                        </>
                    )}

                    {lcneAplyPrcssStatCd == "D" && (
                        <>
                            <Button
                                role="save"
                                onClick={() => {
                                    handler.updateFrgnr("D");
                                }}
                            />
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    handler.updateFrgnrPrcssStat("aprv");
                                }}
                            >
                                {t("B_APRV_RSLT")}
                            </Button>
                        </>
                    )}

                    {lcneAplyPrcssStatCd == "1" && (
                        <>
                            <Button
                                role="save"
                                onClick={() => {
                                    handler.updateFrgnr("save");
                                }}
                            />
                            <Button
                                role="edit"
                                onClick={() => {
                                    navigate(URLS.ptli0919006s + "/" + form.usrFrgnrForm.getValues("coTin"), {
                                        state: form.usrFrgnrForm.getValues(),
                                    });
                                }}
                            />
                            <Button
                                role="submit"
                                onClick={() => {
                                    handler.updateFrgnr("submit");
                                }}
                            />
                            <Button
                                role="delete"
                                onClick={() => {
                                    handler.deleteFrgnr();
                                }}
                            />
                        </>
                    )}
                </Layout.Right>
            </Layout>

            {lcneAplyPrcssStatCd == "M" && (
                <>
                    <Group>
                        <Group.Body>
                            <Layout.Left>
                                <Button
                                    role="excelDown"
                                    onClick={() => {
                                        setLoad(true);
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={t("T_VHCL_INFO")} titleSize={2}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Grid
                                {...grid.vhclInfoList.grid}
                                data={fetch.getFrgnrVhclList.data?.frgnrVhclList}
                                render={render.grid_vhclInfoList}
                            />
                        </Group.Body>
                    </Group>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="new"
                                onClick={() => {
                                    const handleSave = (data: any) => {
                                        // Modal 창에서 받은 데이터 확인
                                        if (data == "save") {
                                            fetch.getFrgnrDtl.fetch();
                                            fetch.getFrgnrVhclList.fetch();
                                            modal.closeModal();
                                        }
                                    };

                                    modal.openModal({
                                        content: (
                                            <PTLI0919004S
                                                data={{
                                                    coTin: form.usrFrgnrForm.getValue("coTin"),
                                                    appNo: form.usrFrgnrForm.getValue("appNo"),
                                                    cstmLcneNo: form.usrFrgnrForm.getValue("cstmLcneNo"),
                                                    lcneYy: form.usrFrgnrForm.getValue("lcneYy"),
                                                    rgsrTrdrNm: form.usrFrgnrForm.getValue("rgsrTrdrNm"),
                                                    trptIssDtm: form.usrFrgnrForm.getValue("lcneIssDtm"),
                                                    appDgr: form.usrFrgnrForm.getValue("appDgr"),
                                                    trprOwrsTrckNo: count,
                                                }}
                                                handleSave={handleSave}
                                            />
                                        ),
                                        size: "md",
                                        draggable: true,
                                        close: false,
                                    });
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="save"
                                onClick={() => {
                                    handler.updateFrgnr("M");
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </>
            )}
            <Group hidden>
                <Grid {...grid.vhclInfoExcelList.grid} data={fetch.getFrgnrVhclExcelList.data?.frgnrVhclExcelList} />
            </Group>
        </Page>
    );
};
